module.exports = __webpack_public_path__ + "static/img/Hintergrund.fdaf532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hintergrund.jpg
// module id = 07Yx
// module chunks = 2